/**
 * Global Project Configuration
 *
 * This file contains configuration constants that can be adjusted by the development/admin team.
 */

export const CONFIG = {
    /**
     * Duration in days for a Demo tenant license.
     * When "Is Demo" is checked, the license expiration will be set to (Current Date + This Value).
     */
    DEMO_DURATION_DAYS: Number(import.meta.env.VITE_DEMO_DURATION_DAYS) || 15,
};
